import api from './api';

const notificationService = {
  /**
   * Get all notifications for the current user
   * @param {Object} params - Query parameters (per_page, unread)
   */
  getNotifications: async (params = {}) => {
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  /**
   * Get count of unread notifications
   */
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data.count;
  },

  /**
   * Mark a specific notification as read
   * @param {number} id - Notification ID
   */
  markAsRead: async (id) => {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    const response = await api.post('/notifications/mark-all-read');
    return response.data;
  },

  /**
   * Delete a notification
   * @param {number} id - Notification ID
   */
  deleteNotification: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },
};

export default notificationService;
